<template>
  <b-nav pills vertical>
    <b-nav-item :to="{name: 'profile-edit'}"><translate>Personal Info</translate></b-nav-item>
    <b-nav-item :to="{name: 'profile-change-password'}"><translate>Change Password</translate></b-nav-item>
    <b-nav-item :to="{name: 'profile-addresses'}"><translate>Personal Addresses</translate></b-nav-item>
  </b-nav>
</template>

<script>

export default {
  name: 'ProfileNavigation'
}
</script>
